import { Link } from 'react-router-dom';
import { MdMarkEmailRead } from 'react-icons/md';
import { translate } from '../../../utils/Common';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

const ForgotPwdSuccess = () => {
    return (
        <div className="animate-fade-in">
            <Alert variant="info">
                <MdMarkEmailRead size={16} aria-hidden="true" />
                <AlertTitle>{translate("login.forgotpwd.success.title")}</AlertTitle>
                <AlertDescription>
                    <p>
                        {translate("login.forgotpwd.success.description1")}<br />
                        {translate("login.forgotpwd.success.description2")}.
                    </p>
                    <p className="mt-2 font-semibold text-secondary">
                        #{translate("login.forgotpwd.success.description3")}
                    </p>
                </AlertDescription>
            </Alert>

            <Button asChild size="lg" className="mt-6 w-full">
                <Link to="/login">{translate("login.forgotpwd.success.accept")}</Link>
            </Button>
        </div>
    );
}

export default ForgotPwdSuccess;
